module.exports = __webpack_public_path__ + "img/exclamation-round.8dbdf926.svg";